<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard w-100 d-block" toggleable="lg" type="dark" variant="primary">
          <b-row>
            <b-col md="6">
              <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
            </b-col>
            <b-col md="6">
              <b-navbar-nav class="pull-right mr-auto">
                <b-nav-form>
                  <ExcelExportButton v-if="failedBillingList.length > 0" service-method="getAllBilllingJobDash"
                    :export-data="getExportPayload()" :filename="'failed-billing-list.xlsx'"
                    button-text="Export As Excel" exporting-text="Downloading Please Wait..." size="sm"
                    variant="warning" button-class="pull-right mb-1" style="font-size: 0.675rem"
                    @export-success="onExportSuccess" @export-error="onExportError" />
                </b-nav-form>
              </b-navbar-nav>
            </b-col>
          </b-row>
        </b-navbar>

        <!-- Filters Section -->
        <b-card>
          <b-row>
            <b-col md="3" class="mb-1">
              <date-range-picker :opens="openRight" :always-show-calendars="showCal" v-model="dateRange"
                :startDate="startDate" :endDate="endDate" :locale-data="locale" />
            </b-col>
            <b-col md="3" class="mb-1">
              <b-form-input :formatter="capitalizeAll" class="mb-1" v-model="Filter.billingSeriesFilter"
                placeholder="Billing Series" />
            </b-col>
            <b-col md="3" class="mb-1">
              <b-form-input :formatter="capitalizeAll" class="mb-1" v-model="Filter.jobNoFilter"
                placeholder="Job Number" />
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select class="mb-1" :list="storeClientList" v-model="Filter.clientFilter"
                option-value="clientId" option-text="clientName" placeholder="Client Name" />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mb-1">
              <b-form-input :formatter="capitalizeAll" v-model="Filter.billingLocationFilter"
                placeholder="Billing Location" />
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select class="mb-1" :list="storeBranchList" v-model="Filter.branchFilter"
                option-value="pickupId" option-text="pickupLocation" placeholder="Branch" />
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select class="mb-1" :list="storeShippingLineList" v-model="Filter.shippingLineFilter"
                option-value="shippingId" option-text="shippingLine" placeholder="Shipping Line" />
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select class="mb-1" :list="jobList" v-model="Filter.jobTypeFilter" option-value="jv"
                option-text="jt" placeholder="Job Type" />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mb-1">
              <model-list-select :list="tallyStatusList" v-model="Filter.tallyStatusFilter" option-value="status"
                option-text="label" placeholder="Tally Status" />
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select class="mb-1" :list="transportTypeList" v-model="Filter.transportTypeFilter"
                option-value="value" option-text="text" placeholder="Transport Type" />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" center>
              <b-button size="sm" class="mb-2" @click="filterSearch" variant="outline-primary">Search</b-button>
              <b-button size="sm" class="ml-2 mb-2" @click="clearFilter" variant="outline-info">Clear</b-button>
            </b-col>
          </b-row>
        </b-card>



        <!-- Status Message -->
        <div v-if="statusMessage" class="status-message mb-3" :class="`alert-${statusType}`">
          <div class="d-flex justify-content-between align-items-center">
            <span>{{ statusMessage }}</span>
            <b-button variant="link" size="sm" @click="clearStatus" class="p-0">
              <i class="fa fa-times"></i>
            </b-button>
          </div>
        </div>

        <!-- Bulk Actions -->
        <div class="bulk-actions mb-3" v-if="failedBillingList.length > 0">
          <b-row>
            <b-col md="3">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="selectAll" @change="toggleSelectAll" class="mr-3">
                  Select All
                </b-form-checkbox>
                <span class="text-muted">
                  {{ selectedItems.length }} of {{ failedBillingList.length }} items selected
                </span>
              </div>
            </b-col>
            <b-col md="4" class="mb-1">
              {{ ImportSeries }}
            </b-col>
            <b-col md="5" class="text-right">
              <b-button variant="success" size="sm" :disabled="selectedItems.length === 0" @click="sendSelectedToTally"
                class="mr-2">
                <i class="fa fa-paper-plane mr-1"></i>
                Send {{ selectedItems.length }} to Tally
              </b-button>
              <b-button variant="outline-secondary" size="sm" :disabled="selectedItems.length === 0"
                @click="clearSelection" class="mr-2">
                Clear Selection
              </b-button>
              <b-button variant="info" size="sm" @click="triggerExcelImport">
                <i class="fa fa-file-excel-o mr-1"></i>
                Import Excel
              </b-button>
            </b-col>
          </b-row>

          <!-- Pagination Info and Controls -->
          <b-row class="mt-3 pt-3 border-top">
            <b-col md="6">
              <h6 class="text-muted mb-0">
                <small v-if="isLoading == false">
                  {{ pagination.totalRows }} Entries | Page {{ pagination.currentPage }} of {{ totalPages }}
                </small>
              </h6>
            </b-col>
            <b-col md="6" class="text-right">
              <div class="d-flex align-items-center justify-content-end">
                <span class="text-muted mr-2">Items per page:</span>
                <model-list-select :list="PaginationList" v-model="PaginationCount" option-value="pagv"
                  option-text="pagt" placeholder="Select" @input="pagechangeData()" style="width: 80px;" />
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- Hidden File Input for Excel Import -->
        <input ref="excelFileInput" type="file" accept=".xlsx,.xls" style="display: none" @change="handleExcelFile" />

        <!-- Data Table -->
        <div class="table-responsive tableMain mt-2">
          <b-table show-empty stacked="md" :items="failedBillingList" :fields="fields" :per-page="pagination.perPage"
            :sort-by.sync="pagination.sortBy" :sort-desc.sync="pagination.sortDesc"
            :sort-direction="pagination.sortDirection">

            <!-- Select Checkbox -->
            <template slot="select" slot-scope="row">
              <b-form-checkbox :value="row.item.billingId" v-model="selectedItems"
                :disabled="row.item.addedToTallySucessStatus == 0">
              </b-form-checkbox>
            </template>

            <!-- Row Number -->
            <template slot="rowNumber" slot-scope="row0">
              <span>{{ row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage }}</span>
            </template>

            <!-- Billing Information -->
            <template slot="billingInfo" slot-scope="row1">
              <div class="info-group">
                <div><b>Series:</b> {{ row1.item.billingSeries }}</div>
                <div><b>Location:</b> {{ row1.item.billingLocationName }}</div>
                <div><b>Date:</b> {{ row1.item.InvDate | moment }}</div>
                <div>
                  <b-badge :variant="row1.item.addedToTallySucessStatus == 1 ? 'success' : 'warning'">
                    {{ row1.item.addedToTallySucessStatus == 1 ? 'Added to Tally' : 'Pending' }}
                  </b-badge>
                </div>
              </div>
            </template>

            <!-- Job Information -->
            <template slot="jobInfo" slot-scope="row2">
              <div class="info-group">
                <div><b>Job No:</b> {{ row2.item.JobNo }}</div>
                <div><b>Date:</b> {{ row2.item.JobDate | moment }}</div>
                <div><b>Type:</b> <b-badge variant="info">{{ row2.item.jobType }}</b-badge></div>
                <div><b>Transport:</b> {{ row2.item.TransportType }}</div>
              </div>
            </template>

            <!-- Dates Information -->
            <template slot="datesInfo" slot-scope="row3">
              <div class="info-group">
                <div><b>SOB:</b> {{ row3.item.SobDate || '-----------' }}</div>
                <div><b>ETA Est:</b> {{ row3.item.EtaDestinationEstimated || '-----------' }}</div>
                <div><b>ETA Act:</b> {{ row3.item.EtaDestinationActual || '-----------' }}</div>
              </div>
            </template>

            <!-- Vessel & BL Information -->
            <template slot="vesselInfo" slot-scope="row4">
              <div class="info-group">
                <div><b>Leg1 Vessel:</b> {{ row4.item.Leg1Vessel || '-----------' }}</div>
                <div><b>Leg1 Voyage:</b> {{ row4.item.Leg1Voyage || '-----------' }}</div>
                <div><b>MBL No:</b> {{ row4.item.MblNo || '-----------' }}</div>
                <div><b>MBL Date:</b> {{ row4.item.MblDate || '-----------' }}</div>
                <div><b>HBL No:</b> {{ row4.item.HblNo || '-----------' }}</div>
                <div><b>Billing Type:</b> {{ row4.item.BillingType || '-----------' }}</div>
                <div><b>BL Type:</b> {{ row4.item.BlType || '-----------' }}</div>
              </div>
            </template>

            <!-- Freight Terms -->
            <template slot="freightTerms" slot-scope="row5">
              <div class="info-group">
                <div><b>HBL Terms:</b> {{ row5.item.FrghtTermsHbl || '-----------' }}</div>
                <div><b>MBL Terms:</b> {{ row5.item.FrghtTermsMbl || '-----------' }}</div>
                <div><b>Liner Terms:</b> {{ row5.item.FrghtTermsLiner || '-----------' }}</div>
              </div>
            </template>

            <!-- Location Information -->
            <template slot="locationInfo" slot-scope="row6">
              <div class="info-group">
                <div><b>Pickup:</b> {{ row6.item.Pickup || '-----------' }}</div>
                <div><b>Handover:</b> {{ row6.item.Handover || '-----------' }}</div>
                <div><b>Stuff:</b> {{ row6.item.Stuff || '-----------' }}</div>
                <div><b>POL:</b> {{ row6.item.Pol || '-----------' }}</div>
                <div><b>POD:</b> {{ row6.item.Pod || '-----------' }}</div>
                <div><b>FPOD:</b> {{ row6.item.Fpod || '-----------' }}</div>
                <div><b>POR:</b> {{ row6.item.Por || '-----------' }}</div>
                <div><b>Branch:</b> <b-badge variant="secondary">{{ row6.item.Branch || '-----------' }}</b-badge>
                </div>
                <div><b>Shipping Line:</b> {{ row6.item.Sline || '-----------' }}</div>
              </div>
            </template>

            <!-- Client Information -->
            <template slot="clientInfo" slot-scope="row7">
              <div class="info-group">
                <div><b>Client:</b> {{ row7.item.Client }}</div>
                <div><b>Importer:</b> {{ row7.item.ImporterClient || '-----------' }}</div>
                <div><b>Exporter:</b> {{ row7.item.ExporterClient || '-----------' }}</div>
              </div>
            </template>

            <!-- User Information -->
            <template slot="userInfo" slot-scope="row8">
              <div class="info-group">
                <div><b>Raised By:</b> <b-badge variant="info">{{ row8.item.RaisedBy || '-----------' }}</b-badge>
                </div>
                <div><b>Created By:</b> <b-badge variant="success">{{ row8.item.CreatedBy || '-----------'
                }}</b-badge></div>
              </div>
            </template>

            <!-- Actions -->
            <template slot="actions" slot-scope="row15">
              <b-button
                @click="proceedBilling(row15.item.billingId, row15.item.jobType, row15.item.isMultiBilling, row15.item.billingSeries)"
                variant="primary" size="sm">
                {{ row15.item.addedToTallySucessStatus == 0 ? "View Billing" : "Proceed To Billing" }}
              </b-button>
            </template>
          </b-table>
        </div>

        <!-- Bottom Pagination -->
        <div>
          <b-pagination limit="5" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total-rows="pagination.totalRows" @change="onPageChange($event)" />
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import {
  globalPermissionStatus,
  lastVisitPage,
  GlobalGetLocation,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import CustomLoader from "../common/customLoader.vue";
import MasterService from "../../services/MasterService.js";
import ExcelExportButton from "../common/ExcelExportButton.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", "/viewBillingDetails/viewBillingDetails");
      this.getFailedBillingList("0", "1", "1");
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      ImportSeries: "",
      // Filter variables
      Filter: {
        billingSeriesFilter: "",
        billingLocationFilter: "",
        jobNoFilter: "",
        jobTypeFilter: "",
        transportTypeFilter: "",
        clientFilter: "",
        branchFilter: "",
        shippingLineFilter: "",
        tallyStatusFilter: "0",
      },

      // Pagination
      pagination: {
        totalRows: 0,
        currentPage: 1,
        perPage: 25,
        sortBy: null,
        sortDesc: false,
        sortDirection: "asc",
      },

      // Data
      failedBillingList: [],
      isLoading: false,
      selectedItems: [],
      selectAll: false,
      statusMessage: "",
      statusType: "info", // success, warning, danger, info

      // Date picker
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        ],
        firstDay: 0,
      },

      // Filter lists
      jobList: [
        { jv: "FF", jt: "FF" },
        { jv: "CC", jt: "CC" },
        { jv: "TPT", jt: "TPT" },
      ],
      transportTypeList: [
        { text: "Import", value: "IMPORT" },
        { text: "Export", value: "EXPORT" },
        { text: "Cross Country", value: "CRC" },
      ],
      tallyStatusList: [
        { status: "0", label: "Pending" },
        { status: "1", label: "Added to Tally" },
        { status: "2", label: "All" },
      ],
      PaginationList: [
        { pagv: "25", pagt: "25" },
        { pagv: "50", pagt: "50" },
        { pagv: "75", pagt: "75" },
        { pagv: "100", pagt: "100" },
        { pagv: "150", pagt: "150" },
        { pagv: "200", pagt: "200" },
      ],
      PaginationCount: "25",

      // Table fields
      fields: [
        {
          key: "select",
          label: "Select",
          sortable: false,
        },
        {
          key: "rowNumber",
          label: "#",
          sortable: false,
        },
        {
          key: "billingInfo",
          label: "Billing Information",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "jobInfo",
          label: "Job Information",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "datesInfo",
          label: "Dates Information",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "vesselInfo",
          label: "Vessel & BL Information",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "freightTerms",
          label: "Freight Terms",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "locationInfo",
          label: "Location Information",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "clientInfo",
          label: "Client Information",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "userInfo",
          label: "User Information",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
        },
      ],
      getAll: "0",
      isExcelImport: false,
    };
  },

  mounted() {
    this.getFailedBillingList("0", "1", "1");
    this.fetchStoreData();
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    MultiSelect,
    DateRangePicker,
    CustomLoader,
    ExcelExportButton,
  },

  computed: {
    totalPages() {
      return Math.ceil(this.pagination.totalRows / this.pagination.perPage);
    },
    hasNextPage() {
      return this.pagination.currentPage < this.totalPages;
    },
    hasPreviousPage() {
      return this.pagination.currentPage > 1;
    },

    // Store-based filter data
    storeClientList() {
      return this.$store.getters['common/getAllClientList'] || [];
    },
    storeShippingLineList() {
      return this.$store.getters['common/getAllShippingLineList'] || [];
    },
    storeBranchList() {
      return this.$store.getters['common/getAllBranchList'] || [];
    },
  },

  watch: {
    selectedItems: {
      handler(newVal) {
        // Update selectAll state based on selection
        const selectableItems = this.failedBillingList.filter(item => item.addedToTallySucessStatus != 0);
        if (selectableItems.length > 0) {
          this.selectAll = newVal.length === selectableItems.length;
        } else {
          this.selectAll = false;
        }
      },
      deep: true
    },

    // Monitor store data changes
    storeClientList: {
      handler(newVal) {
        console.log('Client list updated:', newVal);
      },
      deep: true
    },
    storeShippingLineList: {
      handler(newVal) {
        console.log('Shipping line list updated:', newVal);
      },
      deep: true
    },
    storeBranchList: {
      handler(newVal) {
        console.log('Branch list updated:', newVal);
      },
      deep: true
    }
  },

  methods: {
    wordWrap,

    // Text formatter
    capitalizeAll(value) {
      if (!value) return value;
      return value.toString().toUpperCase();
    },

    // Main data fetching method
    getFailedBillingList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      console.log('Fetching failed billing list...');
      this.isLoading = true;
      this.failedBillingList = [];

      let payload = {
        Filter: this.Filter,
        dateRange: this.dateRange,
        fromSearch: SEARCH || "1",
        page: CURRENT || "1", // Changed from "0" to "1" for new API
        pageSize: this.pagination.perPage,
        fromDate: this.dateRange.startDate,
        toDate: this.dateRange.endDate,
        getAll: this.getAll,
      };

      console.log('Filter payload:', payload);

      NodeLockPannelService.getAllBilllingJobDash(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("API Response:", data);

          if (status == 200 && data) {
            if (data.data && data.data.length > 0) {
              this.failedBillingList = data.data;
              this.getAll = "0";
              // Handle new pagination structure
              if (data.pagination) {
                this.pagination.totalRows = data.pagination.totalCount || 0;
                this.pagination.currentPage = data.pagination.currentPage || 1;
                this.pagination.perPage = data.pagination.pageSize || this.pagination.perPage;

                // Update pagination count dropdown to match API response
                if (data.pagination.pageSize && !this.PaginationList.find(p => p.pagv == data.pagination.pageSize)) {
                  this.PaginationCount = data.pagination.pageSize.toString();
                }
              } else {
                // Fallback to old structure
                this.pagination.totalRows = data.totalRows || data.data.length;

                // Handle pagination
                if (SEARCH != "2") {
                  this.pagination.currentPage = 1;
                } else {
                  this.pagination.currentPage = pageNumber || 1;
                }
              }
            } else {
              this.failedBillingList = [];
              this.pagination.totalRows = 0;
            }
          } else {
            console.error("API response error:", data);
            this.failedBillingList = [];
            this.totalRows = 0;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching billing job data:", error);
          this.failedBillingList = [];
          this.pagination.totalRows = 0;
          this.isLoading = false;
        });
    },

    // Filter methods
    filterSearch() {
      this.getFailedBillingList("0", "1", "1");
    },

    clearFilter() {
      this.Filter = {
        billingSeriesFilter: "",
        billingLocationFilter: "",
        jobNoFilter: "",
        transportTypeFilter: "",
        clientFilter: "",
        branchFilter: "",
        shippingLineFilter: "",
        tallyStatusFilter: "",
      };
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
      // Clear selection when filters change
      this.clearSelection();
      this.getFailedBillingList("0", "1", "1");
    },

    // Pagination methods
    onPageChange(event) {
      // For new API structure, we can pass the page number directly
      // The API will handle the offset calculation
      this.getFailedBillingList("0", "2", event);
    },

    pagechangeData() {
      this.pagination.perPage = this.PaginationCount;
      this.getFailedBillingList("0", "1", "1");
    },

    // Billing action
    proceedBilling(billingId, jobType, isMultiBilling, billingSeries) {
      this.$sessionsStorage.set("editSalesExId", billingId);
      if (isMultiBilling == 1) {
        this.$router.push({
          path: "/consolidation/viewBillingDetails/" + billingId,
          query: { mainSalesSeries: billingSeries },
        });
      } else {
        this.$router.push({
          path: "/allModuleForm/newTallyBillingMerge/" + billingId,
        });
      }
    },

    // Selection methods
    toggleSelectAll() {
      if (this.selectAll) {
        // Select all items that are not already added to tally
        this.selectedItems = this.failedBillingList
          .filter(item => item.addedToTallySucessStatus != 0)
          .map(item => item.billingId);
      } else {
        this.selectedItems = [];
      }
    },

    clearSelection() {
      this.selectedItems = [];
      this.selectAll = false;
    },

    clearStatus() {
      this.statusMessage = "";
      this.statusType = "info";
    },

    showStatus(message, type = "info") {
      this.statusMessage = message;
      this.statusType = type;
      // Auto-hide after 5 seconds
      setTimeout(() => {
        this.clearStatus();
      }, 5000);
    },

    // Bulk send to tally
    async sendSelectedToTally() {
      // Validation checks
      if (this.selectedItems.length === 0) {
        this.showStatus('Please select items to send to Tally', 'warning');
        return;
      }

      // Check if any selected items are already sent to Tally
      const alreadySentItems = this.failedBillingList.filter(item =>
        this.selectedItems.includes(item.billingId) && item.addedToTallySucessStatus == 0
      );

      if (alreadySentItems.length > 0) {
        this.showStatus(`${alreadySentItems.length} selected items are already sent to Tally`, 'warning');
        return;
      }

      // Confirmation dialog
      const confirmed = confirm(
        `Are you sure you want to send ${this.selectedItems.length} billing items to Tally?\n\nThis action cannot be undone.`
      );

      if (!confirmed) {
        return;
      }

      try {
        let selectedData = this.failedBillingList.filter(item =>
          this.selectedItems.includes(item.billingId) && item.addedToTallySucessStatus != 0
        );
        this.isLoading = true;
        this.showStatus(`Sending ${this.selectedItems.length} items to Tally...`, 'info');

        if (this.isExcelImport) {
          console.log("this.selectedItems=>", this.selectedItems);
          selectedData = this.selectedItems;
        }
        // Get selected items data (only pending items)

        if (selectedData.length === 0) {
          this.showStatus('No valid items to send to Tally', 'warning');
          return;
        }

        // Prepare comprehensive payload
        const payload = {
          billingIds: this.isExcelImport? this.selectedItems : selectedData.map(item => item.billingId),
          items: selectedData.map(item => ({
            billingId: item.billingId,
            jobNo: item.jobNo,
            jobType: item.jobType,
            billingSeries: item.billingSeries,
            billingLocationName: item.billingLocationName,
            clientName: item.clientName,
            isMultiBilling: item.isMultiBilling || 0,
            invDate: item.InvDate,
            totalAmount: item.totalAmount || 0
          })),
          totalCount: selectedData.length,
          timestamp: new Date().toISOString()
        };

        console.log('Sending to Tally - Payload:', payload);

        // Make API call
        const response = await axios({
          method: "POST",
          url: `${URL_BASE}/Api_TallyBilling/bulkSendFailedTallyIds.php`,
          data: JSON.stringify(payload),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
          timeout: 30000 // 30 second timeout
        });

        const { status, data } = response;

        if (status === 200 && data) {
          this.isExcelImport = false;
          // Handle bulk processing response
          if (data.msg === "Bulk Tally processing completed") {
            const { totalProcessed, successCount, failureCount, results } = data;

            // Show comprehensive results
            if (failureCount === 0) {
              this.showStatus(`✅ All ${successCount} items successfully sent to Tally`, 'success');
            } else if (successCount === 0) {
              this.showStatus(`❌ All ${failureCount} items failed to send to Tally`, 'danger');
            } else {
              this.showStatus(`⚠️ ${successCount} sent successfully, ${failureCount} failed`, 'warning');
            }

            // Show detailed results if available
            if (results && results.length > 0) {
              // Generate Excel report from results
              this.generateTallyResultsExcel(results);

              setTimeout(() => {
                const failedItems = results.filter(r => r.status !== 'success');
                if (failedItems.length > 0) {
                  const failedDetails = failedItems.map(item =>
                    `Billing ID ${item.billingId}: ${item.message || 'Unknown error'}`
                  ).join(', ');
                  this.showStatus(`Failed items: ${failedDetails}`, 'danger');
                }
              }, 3000);
            }

            // Clear selection and refresh data
            this.clearSelection();
            await this.getFailedBillingList("0", "1", "1");

          } else if (data.msg === "Inserted Successfully" || data.success === true) {
            this.showStatus(`Successfully sent ${selectedData.length} items to Tally`, 'success');
            this.clearSelection();
            await this.getFailedBillingList("0", "1", "1");

          } else if (data.msg === "Data Updated Successfully") {
            this.showStatus(`Updated ${selectedData.length} items in Tally`, 'success');
            this.clearSelection();
            await this.getFailedBillingList("0", "1", "1");

          } else {
            this.showStatus(`Tally response: ${data.msg || 'Unknown response'}`, 'warning');
          }
        } else {
          throw new Error(`Invalid response: Status ${status}`);
        }

      } catch (error) {
        console.error('Error sending to Tally:', error);

        // Handle different error types
        if (error.code === 'ECONNABORTED') {
          this.showStatus('Request timeout - Please try again', 'danger');
        } else if (error.response) {
          const status = error.response.status;
          const message = error.response.data.message || error.response.statusText;
          this.showStatus(`Server error (${status}): ${message}`, 'danger');
        } else if (error.request) {
          this.showStatus('Network error - Please check your connection', 'danger');
        } else {
          this.showStatus(`Error: ${error.message}`, 'danger');
        }
      } finally {
        this.isLoading = false;
      }
    },

    // Excel Import functionality
    triggerExcelImport() {
      this.$refs.excelFileInput.click();
    },

    async handleExcelFile(event) {
      this.isExcelImport = true;
      const file = event.target.files[0];
      if (!file) return;

      // Validate file type
      const allowedTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel' // .xls
      ];

      if (!allowedTypes.includes(file.type)) {
        this.showStatus('Please select a valid Excel file (.xlsx or .xls)', 'danger');
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        this.showStatus('File size must be less than 5MB', 'danger');
        return;
      }

      try {
        this.isLoading = true;
        this.showStatus('Loading all data and processing Excel file...', 'info');


        // Read Excel file
        const billingIds = await this.parseExcelFile(file);
        this.ImportSeries = billingIds.join(', ');
        if (billingIds.length === 0) {
          this.showStatus('No valid billing IDs found in Excel file', 'warning');
          return;
        }

        // Now validate billing IDs via API call
        const validBillingIds = await this.validateImportedBillingIds(billingIds);

        if (validBillingIds.length === 0) {
          this.showStatus('No matching billing IDs found in current data', 'warning');
          return;
        }

        // Show confirmation
        const confirmed = confirm(
          `Found ${validBillingIds.length} valid billing IDs in Excel file.\n\nDo you want to send these items to Tally?`
        );

        if (confirmed) {
          // Set selected items and send to Tally
          this.selectedItems = validBillingIds;
          // await this.sendSelectedToTally();
        }

      } catch (error) {
        console.error('Error processing Excel file:', error);
        this.showStatus('Error processing Excel file. Please check the format.', 'danger');
      } finally {
        this.isLoading = false;
        event.target.value = '';
      }
    },

    async parseExcelFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });

            // Get first worksheet
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            // Convert to JSON
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            // Extract billing IDs from first column (Row Labels)
            const billingIds = [];

            for (let i = 1; i < jsonData.length; i++) { // Skip header row
              const row = jsonData[i];
              if (row && row[0]) {
                const rowLabel = String(row[0]).trim();
                if (rowLabel && rowLabel !== '') {
                  billingIds.push(rowLabel);
                }
              }
            }

            resolve(billingIds);
          } catch (error) {
            reject(error);
          }
        };

        reader.onerror = () => reject(new Error('Failed to read file'));
        reader.readAsArrayBuffer(file);
      });
    },

    async validateImportedBillingIds(importedIds) {
      try {
        console.log('Validating imported IDs via API:', importedIds);

        const payload = {
          importedIds: importedIds,
          type: 'importExcel'
        };

        const response = await axios({
          method: "POST",
          url: `${URL_BASE}/Api_TallyBilling/bulkSendFailedTallyIds.php`,
          data: JSON.stringify(payload),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
          timeout: 30000
        });

        const { status, data } = response;

        if (status === 200 && data) {
          if (data.error) {
            this.showStatus(`Validation Error: ${data.error}`, 'danger');
            return [];
          } else if (data.billingIds && data.billingIds.length > 0) {
            console.log('Valid billing IDs from API:', data.billingIds);
            return data.billingIds;
          } else {
            this.showStatus('No valid billing IDs found by API', 'warning');
            return [];
          }
        } else {
          throw new Error(`Invalid API response: Status ${status}`);
        }

      } catch (error) {
        console.error('Error validating billing IDs via API:', error);

        if (error.response) {
          const status = error.response.status;
          const message = error.response.data.error || error.response.statusText;
          this.showStatus(`API Error (${status}): ${message}`, 'danger');
        } else if (error.request) {
          this.showStatus('Network error during validation', 'danger');
        } else {
          this.showStatus(`Validation Error: ${error.message}`, 'danger');
        }

        return [];
      }
    },

    generateTallyResultsExcel(results) {
      try {
        // Prepare data for Excel with updated API response structure
        const excelData = results.map((result, index) => ({
          'S.No': index + 1,
          'Billing ID': result.billingId,
          'Billing Series': result.billingSeries || 'N/A',
          'Job Number': result.jobNumber || 'N/A',
          'Job Type': result.jobType || 'N/A',
          'Success': result.success ? 'Yes' : 'No',
          'Status': result.status,
          'Message': result.message,
          'Tally Voucher ID': result.tallyVoucherId || 'N/A',
          'XML Source': result.xmlSource || 'N/A',
          'Tally Response': result.tallyResponse ? JSON.stringify(result.tallyResponse) : 'N/A',
          'Processed Date': new Date().toLocaleString()
        }));

        // Create workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Set column widths for better readability
        const columnWidths = [
          { wch: 8 },   // S.No
          { wch: 20 },  // Billing ID
          { wch: 18 },  // Billing Series
          { wch: 15 },  // Job Number
          { wch: 12 },  // Job Type
          { wch: 10 },  // Success
          { wch: 12 },  // Status
          { wch: 30 },  // Message
          { wch: 20 },  // Tally Voucher ID
          { wch: 15 },  // XML Source
          { wch: 50 },  // Tally Response
          { wch: 20 }   // Processed Date
        ];
        worksheet['!cols'] = columnWidths;

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Tally Results');

        // Generate filename with timestamp
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
        const filename = `Tally_Results_${timestamp}.xlsx`;

        // Save file
        XLSX.writeFile(workbook, filename);

        this.showStatus(`Excel report generated: ${filename}`, 'success');

      } catch (error) {
        console.error('Error generating Excel report:', error);
        this.showStatus('Error generating Excel report', 'danger');
      }
    },

    // Store data fetching
    async fetchStoreData() {
      try {
        // Fetch all required filter data from store with proper payloads
        const storePromises = [
          this.$store.dispatch(
            "common/setAllBranchList",
            JSON.stringify({
              filter: "BranchList",
              active: "all",
            })
          ),
          this.$store.dispatch(
            "common/setAllClientList",
            JSON.stringify({ itemCode: "ClientList" })
          ),
          this.$store.dispatch(
            "common/setAllShippingLineList",
            JSON.stringify({ itemCode: "ShippingLineList" })
          ),
          this.$store.dispatch(
            "commonDropdownMaster/setAllSlineAccDDList",
            JSON.stringify({
              itemCode: "AllSlineAccDDList",
            })
          ),
        ];

        // Wait for all store actions to complete
        await Promise.all(storePromises);

        // Add a small delay to ensure data is properly loaded
        await new Promise(resolve => setTimeout(resolve, 1000));

        console.log('Store data loaded:', {
          clients: this.storeClientList.length,
          shippingLines: this.storeShippingLineList.length,
          branches: this.storeBranchList.length
        });
      } catch (error) {
        console.error('Error fetching store data:', error);
      }
    },

    // Excel export methods
    getExportPayload() {
      this.generateExcel = "1";
      return {
        type: "Excel",
        Filter: this.Filter,
        fromDate: this.dateRange.startDate,
        toDate: this.dateRange.endDate,
        isAllNo: 1,
        generateExcel: this.generateExcel,
      };
    },

    onExportSuccess(response) {
      console.log('Export successful:', response);
      this.getFailedBillingList("0", "1", "1");
    },

    onExportError(error) {
      console.error('Export failed:', error);
    },
  },
};
</script>

<style>
.custom-badge {
  font-size: 0.8rem;
  padding: 5px 5px;
}

.info-group {
  font-size: 0.85rem;
  line-height: 1.4;
}

.info-group>div {
  margin-bottom: 2px;
  padding: 1px 0;
}

.info-group>div:last-child {
  margin-bottom: 0;
}

.info-group b {
  color: #495057;
  font-weight: 600;
}

.table-responsive {
  overflow-x: auto;
}

.b-table {
  min-width: 1200px;
}

.bulk-actions {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.bulk-actions .btn {
  font-size: 0.875rem;
}

.bulk-actions .text-muted {
  font-size: 0.875rem;
}

/* Disable checkbox for items already in tally */
.b-form-checkbox:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Status message styling */
.status-message {
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid;
  font-size: 0.875rem;
}

.status-message.alert-success {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.status-message.alert-warning {
  background-color: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.status-message.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.status-message.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}

.status-message .btn-link {
  color: inherit;
  text-decoration: none;
}

.status-message .btn-link:hover {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// viewBillingDetails.vue?5be666dd